export default __webpack_public_path__ + "static/fa-regular-400-77206a6bb316fa0aded5083cc57f92b9.eot";